import mitt from 'mitt';

export interface Events {
  notify: {
    success: boolean
    msg: string
  }
  toggleFilters: {
    value: boolean
  }
  highlightPoint: {
    value: string
    highlighted: boolean
  }
  compSearch: string | null
  hide_tooltip: any
  update_tooltip_text: any
  show_tooltip: Record<any, any>
  highlightLine: Record<any, any>
  fetchData: any
}

const emitter = mitt<Events>();

export const EventBus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
};
